var _line, _circle, _line2, _circle2, _line3, _circle3, _line4, _circle4, _line5, _circle5, _line6, _circle6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBackgroundSvg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 486,
    height: 241,
    viewBox: "0 0 486 241",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 5.06066,
    y1: 1.93934,
    x2: 227.061,
    y2: 223.939,
    stroke: "#B4B6BC",
    strokeWidth: 3
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 233.5,
    cy: 230.5,
    r: 9,
    stroke: "#B4B6BC",
    strokeWidth: 3
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 1.06066,
    y1: 70.9393,
    x2: 81.0607,
    y2: 150.939,
    stroke: "#B4B6BC",
    strokeWidth: 3
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 87.5,
    cy: 157.5,
    r: 9,
    stroke: "#B4B6BC",
    strokeWidth: 3
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 199.061,
    y1: 1.93934,
    x2: 321.061,
    y2: 123.939,
    stroke: "#B4B6BC",
    strokeWidth: 3
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 327.5,
    cy: 130.5,
    r: 9,
    stroke: "#B4B6BC",
    strokeWidth: 3
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 274.061,
    y1: 1.93934,
    x2: 469.061,
    y2: 196.939,
    stroke: "#B4B6BC",
    strokeWidth: 3
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 475.5,
    cy: 203.5,
    r: 9,
    stroke: "#B4B6BC",
    strokeWidth: 3
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 347.061,
    y1: 1.93934,
    x2: 451.061,
    y2: 105.939,
    stroke: "#B4B6BC",
    strokeWidth: 3
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 457.5,
    cy: 112.5,
    r: 9,
    stroke: "#B4B6BC",
    strokeWidth: 3
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 78.0607,
    y1: 1.93934,
    x2: 209.061,
    y2: 132.939,
    stroke: "#B4B6BC",
    strokeWidth: 3
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 215.5,
    cy: 139.5,
    r: 9,
    stroke: "#B4B6BC",
    strokeWidth: 3
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundSvg);
export default __webpack_public_path__ + "static/media/backgroundSVG.3d666fdc4b7c699edf08502e2b37efb3.svg";
export { ForwardRef as ReactComponent };